(function () {
  function rank(products, cart, threshold, limit) {
    const excluded = new Set((cart.items || []).map(item => String(item.product_id)));
    const gap = cart.currency === 'USD' && Number.isFinite(threshold) && threshold > 0 ? Math.max(0, threshold - cart.total_price) : 0;
    return products.filter(p => !excluded.has(String(p.id)) && Number.isFinite(p.price) && p.price >= 0)
      .sort((a,b) => gap > 0 ? Math.abs(a.price-gap)-Math.abs(b.price-gap) || a.index-b.index : a.index-b.index).slice(0,limit);
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { rank };
  if (typeof window === 'undefined' || customElements.get('ressalina-cart-recommendations')) return;
  class Recommendations extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('[data-card]'));
      this.status = this.querySelector('[data-status]');
      this.animations=new Map();
      this.change = event => {
        const select = event.target.closest('[data-variant]');
        if (select) select.closest('[data-card]').querySelector('[data-add]').disabled = !select.value;
      };
      this.click = event => {
        const imageNav=event.target.closest('[data-image-prev],[data-image-next]');
        if(imageNav){
          const gallery=imageNav.closest('[data-gallery-wrap]').querySelector('[data-gallery]');
          this.hydrateGallery(gallery);
          const sign=(imageNav.hasAttribute('data-image-next')?1:-1)*(getComputedStyle(this).direction==='rtl'?-1:1);
          this.slide(gallery,gallery.scrollLeft+gallery.clientWidth*sign);
          return;
        }
        const nav = event.target.closest('[data-prev], [data-next]');
        if (nav) {
          const track=this.querySelector('[data-grid]');
          const rtl=getComputedStyle(this).direction==='rtl';
          const forward=nav.hasAttribute('data-next');
          const card=track.querySelector('[data-card]:not([hidden])');
          const gap=parseFloat(getComputedStyle(track).columnGap)||0;
          const step=card.getBoundingClientRect().width+gap;
          this.slide(track,track.scrollLeft+step*Math.max(1,Math.floor((track.clientWidth+gap+.5)/step))*(forward?1:-1)*(rtl?-1:1));
          return;
        }
        const button = event.target.closest('[data-add]'); if (button && !button.disabled) this.add(button);
      };
      this.refresh = () => { if(this.hasAttribute('data-drawer') && !this.visible)return; this.load(); };
      this.cartChange = event => { if (!event.target.closest('ressalina-cart-recommendations') && event.target.closest('[class*="cart"], [id*="cart"]')) this.queue(); };
      this.queue = () => { clearTimeout(this.timer); this.timer=setTimeout(this.refresh,250); };
      this.observer = new MutationObserver(records => {
        if (records.some(record => record.target instanceof Element && !record.target.closest('ressalina-cart-recommendations,ressalina-shipping-progress') && record.target.closest('[class*="cart"], [id*="cart"]'))) this.queue();
      });
      this.observer.observe(document.body,{childList:true,subtree:true});
      document.addEventListener('change',this.cartChange);
      this.addEventListener('change',this.change);
      this.addEventListener('click',this.click);
      this.onScroll=event=>{
        if(event.target.matches('[data-gallery]')){
          const gallery=event.target;
          const count=gallery.parentElement.querySelector('[data-image-count]');
          const text=(Math.round(Math.abs(gallery.scrollLeft)/gallery.clientWidth)+1)+' / '+gallery.children.length;
          if(count&&count.textContent!==text) count.textContent=text;
        }
      };
      this.addEventListener('scroll',this.onScroll,true);
      this.pointerDown=event=>{
        const touchGallery=event.pointerType==='touch'&&event.target.closest('[data-gallery]');
        if((event.pointerType!=='mouse'&&!touchGallery)||(event.pointerType==='mouse'&&event.button!==0)||event.target.closest('button,select,a,input')) return;
        const track=event.target.closest('[data-gallery],[data-grid]');
        if(!track)return;
        if(track.hasAttribute('data-gallery'))this.hydrateGallery(track);
        cancelAnimationFrame(this.animations.get(track));
        this.animations.delete(track);
        this.dragState={track,start:event.clientX,scroll:track.scrollLeft,moved:false,last:event.clientX,time:performance.now(),velocity:0};
        track.setPointerCapture(event.pointerId);
      };
      this.pointerMove=event=>{
        const drag=this.dragState;if(!drag)return;
        const delta=event.clientX-drag.start;
        if(Math.abs(delta)>5){
          const now=performance.now();
          drag.velocity=(drag.last-event.clientX)/Math.max(1,now-drag.time);
          drag.last=event.clientX;drag.time=now;
          drag.moved=true;drag.track.style.scrollSnapType='none';drag.track.setAttribute('data-dragging','');
          drag.target=drag.scroll-delta;
          if(!this.dragFrame)this.dragFrame=requestAnimationFrame(()=>{this.dragFrame=0;if(this.dragState)this.dragState.track.scrollLeft=this.dragState.target;});
          event.preventDefault();
        }
      };
      this.pointerUp=()=>{
        const drag=this.dragState;if(!drag)return;
        cancelAnimationFrame(this.dragFrame);this.dragFrame=0;
        drag.track.removeAttribute('data-dragging');
        if(drag.moved){
          drag.track.scrollLeft=drag.target;
          const card=drag.track.querySelector('[data-card]:not([hidden])');
          const step=drag.track.hasAttribute('data-gallery')?drag.track.clientWidth:card.getBoundingClientRect().width+(parseFloat(getComputedStyle(drag.track).columnGap)||0);
          const velocity=performance.now()-drag.time>100?0:Math.max(-1,Math.min(1,drag.velocity));
          this.slide(drag.track,Math.round((drag.track.scrollLeft+velocity*100)/step)*step,360);
        }else drag.track.style.scrollSnapType='';
        this.dragState=null;
      };
      this.addEventListener('pointerdown',this.pointerDown);
      this.addEventListener('pointermove',this.pointerMove);
      this.addEventListener('pointerup',this.pointerUp);
      this.addEventListener('pointercancel',this.pointerUp);
      this.resizeObserver=new ResizeObserver(()=>{
        const gallery=this.querySelector('[data-card]:not([hidden]) [data-gallery]');
        if(gallery)this.style.setProperty('--gallery-center',gallery.clientHeight/2+'px');
      });
      this.resizeObserver.observe(this.querySelector('[data-grid]'));
      document.addEventListener('cart:updated',this.refresh);
      document.addEventListener('cart:change',this.refresh);
      document.addEventListener('cart:refresh',this.refresh);
      this.galleryFocus=event=>{const gallery=event.target.closest('[data-gallery]');if(gallery)this.hydrateGallery(gallery);};
      this.addEventListener('focusin',this.galleryFocus);
      if(this.hasAttribute('data-drawer')){
        this.visible=false;
        this.visibilityObserver=new IntersectionObserver(entries=>{const visible=entries.some(entry=>entry.isIntersecting);if(visible&&!this.visible){this.visible=true;this.load();}else this.visible=visible;});
        this.visibilityObserver.observe(this);
      }else this.load();
    }
    hydrateGallery(gallery){
      if(!gallery?.dataset.galleryImages)return;
      let sources;
      try{sources=JSON.parse(gallery.dataset.galleryImages);}catch{return;}
      delete gallery.dataset.galleryImages;
      if(!Array.isArray(sources))return;
      const first=gallery.querySelector('img');
      for(const src of sources){
        const image=document.createElement('img');
        image.src=src;image.alt=first?.alt||'';image.loading='lazy';image.decoding='async';
        gallery.append(image);
      }
    }
    slide(track,target,duration=420){
      cancelAnimationFrame(this.animations.get(track));
      const rtl=getComputedStyle(this).direction==='rtl';
      const max=track.scrollWidth-track.clientWidth;
      target=rtl?Math.max(-max,Math.min(0,target)):Math.min(max,Math.max(0,target));
      const start=track.scrollLeft;
      track.style.scrollSnapType='none';
      if(matchMedia('(prefers-reduced-motion: reduce)').matches){track.scrollLeft=target;track.style.scrollSnapType='';this.animations.delete(track);return;}
      const began=performance.now();
      const tick=now=>{
        const t=Math.min(1,(now-began)/duration);
        track.scrollLeft=start+(target-start)*(1-Math.pow(1-t,3));
        if(t<1)this.animations.set(track,requestAnimationFrame(tick));
        else{track.style.scrollSnapType='';this.animations.delete(track);}
      };
      this.animations.set(track,requestAnimationFrame(tick));
    }
    async request(path, options = {}) {
      const response = await fetch((this.dataset.root || '/').replace(/\/?$/, '/') + path, {credentials:'same-origin',cache:'no-store',...options,signal:AbortSignal.timeout(8000)});
      if (!response.ok) throw new Error('Request unavailable');
      return response.json();
    }
    async load() {
      const sequence = this.sequence = (this.sequence || 0) + 1;
      try {
        const cart = await this.request('cart.js');
        if (sequence !== this.sequence || !this.isConnected) return;
        const products = this.cards.map((card,index) => ({id:card.dataset.productId,index,price:Math.min(...Array.from(card.querySelectorAll('option[data-price]')).map(o => Number(o.dataset.price)))}));
        const chosen = rank(products,cart,Number(this.dataset.threshold),Math.max(1,Math.min(12,Number(this.dataset.limit)||8)));
        this.cards.forEach(card => {card.hidden=true;});
        chosen.forEach(product => { const card = this.cards[product.index]; card.hidden=false; this.querySelector('[data-grid]').append(card); });
        this.querySelectorAll('[data-prev],[data-next]').forEach(button=>{button.disabled=chosen.length<2;});
        this.hidden = chosen.length === 0;
      } catch (error) { if(sequence === this.sequence && this.isConnected) this.hidden=true; }
    }
    async add(button) {
      if (this.busy) return;
      const select = button.closest('[data-card]').querySelector('[data-variant]');
      if (!select.value) return;
      this.busy=true;
      button.disabled=true;
      this.status.textContent='';
      try {
        await this.request('cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:select.value,quantity:1}]})});
        this.status.textContent=this.querySelector('[data-added]').textContent;
        document.dispatchEvent(new Event('cart:updated'));
        if (!this.hasAttribute('data-demo')) window.location.assign(this.dataset.cartUrl || '/cart');
      } catch (error) { this.status.textContent=this.querySelector('[data-error]').textContent; }
      finally { this.busy=false; button.disabled=!select.value; }
    }
    disconnectedCallback() {
      this.sequence=(this.sequence||0)+1;
      clearTimeout(this.timer);
      this.visibilityObserver?.disconnect();
      this.removeEventListener('focusin',this.galleryFocus);
      this.observer.disconnect();
      this.resizeObserver.disconnect();
      cancelAnimationFrame(this.dragFrame);
      this.animations.forEach(frame=>cancelAnimationFrame(frame));
      this.removeEventListener('scroll',this.onScroll,true);
      this.removeEventListener('pointerdown',this.pointerDown);
      this.removeEventListener('pointermove',this.pointerMove);
      this.removeEventListener('pointerup',this.pointerUp);
      this.removeEventListener('pointercancel',this.pointerUp);
      document.removeEventListener('change',this.cartChange);
      this.removeEventListener('change',this.change);
      this.removeEventListener('click',this.click);
      ['cart:updated','cart:change','cart:refresh'].forEach(event=>document.removeEventListener(event,this.refresh));
    }
  }
  customElements.define('ressalina-cart-recommendations',Recommendations);
}());
